import { useSyncExternalStore } from "react";
import { subscribe, getSnapshot, onConsentUpdated } from "../stores/ShortbreadStore";

export const useShortbread = () => [useSyncExternalStore(subscribe, getSnapshot), onConsentUpdated] as const;
